/**
 * The one attribute this screen finds an element of its own by.
 *
 * `↵` means "do what this card's primary does", and the primary is a `<button>` for three of the
 * action kinds and a `<Link>` for three others — so there is no single ref to hold, and a handler
 * on the card would only fire while focus was inside it. The same construction
 * `features/attention-queue/lib/queueMarks` uses for the Pulpit's rows, and its own module for the
 * same reason: the component that writes the marker and the hook that reads it are different files.
 */
export const TASK_PRIMARY_ATTRIBUTE = 'data-task-primary';
